const SelectChip = ({ label, icon, selected, onClick, variant = "default" }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all border ${
      selected
        ? "bg-teal-600 text-white border-teal-600 [&_*]:!text-white"
        : variant === "outline"
        ? "bg-white text-gray-700 border-gray-300 hover:border-teal-400 hover:bg-teal-50"
        : "bg-gray-50 text-gray-700 border-gray-200 hover:border-teal-400 hover:bg-teal-50"
    }`}
  >
    {icon && <span className="flex items-center">{icon}</span>}
    {label}
  </button>
);

export default SelectChip;
